export function canUseAppleEedMedicalData(
  appleEedAllowMedicalData: boolean,
  appleEedAdditionalDataExpiresAtUtc: string | null,
  nowMs: number = Date.now(),
): boolean {
  if (!appleEedAllowMedicalData || appleEedAdditionalDataExpiresAtUtc === null) {
    return false;
  }

  const expiresAtMs = Date.parse(appleEedAdditionalDataExpiresAtUtc);
  return !Number.isNaN(expiresAtMs) && nowMs < expiresAtMs;
}

export function appleEedAdditionalDataHasExpired(
  appleEedAdditionalDataExpiresAtUtc: string | null,
  nowMs: number = Date.now(),
): boolean {
  if (appleEedAdditionalDataExpiresAtUtc === null) {
    return false;
  }

  const expiresAtMs = Date.parse(appleEedAdditionalDataExpiresAtUtc);
  return !Number.isNaN(expiresAtMs) && nowMs >= expiresAtMs;
}

export function canUseAppleEedVideoActions(
  appleEedAllowMedicalData: boolean,
  incidentIsReadOnly: boolean,
): boolean {
  return appleEedAllowMedicalData && !incidentIsReadOnly;
}
